// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_AgendaMensalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /so/orders/agenda_mensal?year=YYYY&month=MM
 *
 * Both fields are optional; the controller falls back to the current year/month
 * when they are absent.
 */
import { registerContract } from './validate'

export interface Orders_AgendaMensalInput {
year?: number
month?: number
}

registerContract('Orders_AgendaMensalInput', {
  year:  { type: 'number',  required: false },
  month: { type: 'number',  required: false },
})
